const operationalDataReducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_LINE_CHART_DATA':
      return { ...state, lineChartData: action.payload };
    case 'NULLIFY_DATA':
      return { ...state, historicalData: null };
    case 'SET_ERROR_DATA':
      return { ...state, errorData: action.payload };
    case 'NULLIFY_ERROR_DATA':
      return { ...state, errorData: null };
    case 'NULLIFY_LAST_SYSTEM_DATA':
      return { ...state, lastSystemData: null };
    case 'SET_LAST_DATA':
      return { ...state, lastData: action.payload };
    case 'SET_MINI':
      return { ...state, isSystemMini: true };
    case 'SET_REGULAR':
      return { ...state, isSystemMini: false };
    case 'SET_LAST_SYSTEM_DATA':
      return { ...state, lastSystemData: action.payload };
    case 'SET_LAST_CELL_DATA':
      return { ...state, lastCellData: action.payload };
    case 'SET_HISTORICAL_DATA':
      return { ...state, historicalData: action.payload };
    case 'SET_SELECTED_MODULE':
      return { ...state, selectedModule: action.payload };
    default:
      return state;
  }
};

export default operationalDataReducer;
